import React from 'react';
import PropTypes from 'prop-types';
import LocaleText from '../LocaleText';
import Step from './Step';

class IntroductionLayer extends React.Component {
    render() {
        const { step, nextStep, toggleVisibility, resetSteps, isOpen } = this.props;
        if (!isOpen) {
            return null;
        }
        const closeAndReset = () => {
            toggleVisibility();
            resetSteps();
        };
        const steps = {
            1: {
                showStepIndicators: false,
                image: '/img/intro/01.jpg',
                headline: <LocaleText textKey="layer.one.title" />,
                description: <LocaleText textKey="layer.one.copy" />,
                showSkip: true,
                skipText: <LocaleText textKey="layer.one.cta.secondary" />,
                onSkip: toggleVisibility,
                nextText: <LocaleText textKey="layer.one.cta.primary" />,
                onNext: nextStep,
            },
            2: {
                showStepIndicators: true,
                stepNo: 1,
                totalSteps: 5,
                image: '/img/intro/02.jpg',
                headline: <LocaleText textKey="layer.two.title" />,
                description: <LocaleText textKey="layer.two.copy" />,
                showSkip: true,
                skipText: <LocaleText textKey="layer.two.cta.secondary" />,
                onSkip: closeAndReset,
                nextText: <LocaleText textKey="layer.two.cta.primary" />,
                onNext: nextStep,
            },
            3: {
                showStepIndicators: true,
                stepNo: 2,
                totalSteps: 5,
                image: '/img/intro/03.jpg',
                headline: <LocaleText textKey="layer.three.title" />,
                description: <LocaleText textKey="layer.three.copy" />,
                showSkip: true,
                skipText: <LocaleText textKey="layer.three.cta.secondary" />,
                onSkip: closeAndReset,
                nextText: <LocaleText textKey="layer.three.cta.primary" />,
                onNext: nextStep,
            },
            4: {
                showStepIndicators: true,
                stepNo: 3,
                totalSteps: 5,
                image: '/img/intro/04.jpg',
                headline: <LocaleText textKey="layer.four.title" />,
                description: <LocaleText textKey="layer.four.copy" />,
                showSkip: true,
                skipText: <LocaleText textKey="layer.four.cta.secondary" />,
                onSkip: closeAndReset,
                nextText: <LocaleText textKey="layer.four.cta.primary" />,
                onNext: nextStep,
            },
            5: {
                showStepIndicators: true,
                stepNo: 4,
                totalSteps: 5,
                image: '/img/intro/05.jpg',
                headline: <LocaleText textKey="layer.five.title" />,
                description: <LocaleText textKey="layer.five.copy" />,
                showSkip: true,
                skipText: <LocaleText textKey="layer.five.cta.secondary" />,
                onSkip: closeAndReset,
                nextText: <LocaleText textKey="layer.five.cta.primary" />,
                onNext: nextStep,
            },
            6: {
                showStepIndicators: true,
                stepNo: 5,
                totalSteps: 5,
                image: '/img/intro/06.jpg',
                headline: <LocaleText textKey="layer.six.title" />,
                description: <LocaleText textKey="layer.six.copy" />,
                showSkip: false,
                skipText: '',
                onSkip: closeAndReset,
                nextText: <LocaleText textKey="layer.six.cta.primary" />,
                onNext: closeAndReset,
            },
        };
        return (
            <div className="introduction-layer">
                <div className="introduction-layer__body">
                    <Step {...steps[step]} />
                </div>
            </div>
        );
    }
}

IntroductionLayer.propTypes = {
    step: PropTypes.number.isRequired,
    nextStep: PropTypes.func.isRequired,
    resetSteps: PropTypes.func.isRequired,
};

IntroductionLayer.defaultProps = {
    step: 1,
};

export default IntroductionLayer;
